import {createSelector} from 'reselect'
import {State} from 'lib/store'
import {StudentState} from "./reducer";

const selectStudentsFeature = (state: State): StudentState => state.students

export const getStudentEvaluations = createSelector(selectStudentsFeature, students => students.evaluations)
export const getStudentToGroupComparison = createSelector(selectStudentsFeature, students => students.comparison)
export const getAnalyseFilter = createSelector(selectStudentsFeature, students => students.analyseFilter)